export default __webpack_public_path__ + "static/media/overviewicon.e1582a88.svg";